import { GetRole } from './types';

export const getRole: GetRole = (state, orientation) => {
  if (state.group) return undefined;

  return orientation === 'horizontal' ? 'menubar' : 'menu';
};
